import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Title.css';

const Title = () => {
  const [isFading, setIsFading] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setIsFading(true);

    // Espera a que termine el fade antes de navegar
    setTimeout(() => {
      navigate('/work');
    }, 600); // que coincida con la duración del fade en el CSS
  };

  return (
    <div className={`main-title ${isFading ? 'fade-out' : ''}`} onClick={handleClick}>
      <div className='background-video'>
        <video width="100%"
               height="auto"
               autoPlay
               muted
               loop
               playsInline
               id="myVideo">
          <source src={process.env.PUBLIC_URL + "reel.webm"} type="video/webm" />
        </video>
      </div>
      <div className='sebas-name'>
        {/* <video width="100%"
               height="auto"
               autoPlay
               muted
               loop
               playsInline>
          <source src={`${process.env.PUBLIC_URL}/SEBASCOTO_LOGO_ANIMATION.webm`} type="video/webm"/>
        </video> */}
        <img alt="SebasCotoLogo" src={`${process.env.PUBLIC_URL}/SEBASCOTOLOGOANIMATION.png`}/>
      </div>
    </div>
  );
};

export default Title;
